import { Pipe, PipeTransform } from '@angular/core';

import { ProductPageLinkResolverService } from '../services/product-page-link-resolver.service';

@Pipe({
	name: 'productUrl'
})
export class ProductUrlPipe implements PipeTransform {

	constructor(private productPageLinkResolverService: ProductPageLinkResolverService) { }

	public transform(value: any, assetType: any): any {
		return this.productPageLinkResolverService.getUrlByAssetType(assetType, value?.toString());
	}

}
